import { render, staticRenderFns } from "./Zapier.vue?vue&type=template&id=54010a2e&"
import script from "./Zapier.vue?vue&type=script&lang=js&"
export * from "./Zapier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports